__turbopack_context__.v({
  "button": "BottomOverlayAE-module__51g6Eq__button",
  "column": "BottomOverlayAE-module__51g6Eq__column",
  "container": "BottomOverlayAE-module__51g6Eq__container",
});
